import React from "react";
import PropTypes from "prop-types";
import { Dialog } from 'primereact/dialog';

function ActionDialog({ visible, onHide, actions, title }) {
    return (
        <Dialog
            header={title}
            visible={visible}
            onHide={onHide}
            style={{ width: '90vw', maxWidth: '600px' }}
            className="action-dialog bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 border-0 shadow-lg"
            contentClassName="p-4 sm:p-6 md:p-8 bg-white dark:bg-gray-900"
            headerClassName="bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 border-b border-gray-200 dark:border-gray-700 text-center"
            modal
            draggable={false}
            resizable={false}
        >
            <div className="flex flex-col items-center w-full">
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 md:gap-8 w-full sm:w-auto justify-center">
                    {actions.map((action, idx) => (
                        <button
                            key={idx}
                            onClick={action.onClick}
                            className={`w-full sm:w-[160px] md:w-[200px] h-[120px] sm:h-[160px] md:h-[200px] flex flex-col items-center justify-center rounded-lg shadow-lg transition-all duration-200 border-2
                                ${action.color === "green"
                                    ? "bg-green-100 dark:bg-green-900 border-green-300 dark:border-green-700 hover:bg-green-200 dark:hover:bg-green-800"
                                    : action.color === "orange"
                                        ? "bg-orange-100 dark:bg-orange-900 border-orange-300 dark:border-orange-700 hover:bg-orange-200 dark:hover:bg-orange-800"
                                        : "bg-blue-100 dark:bg-blue-900 border-blue-300 dark:border-blue-700 hover:bg-blue-200 dark:hover:bg-blue-800"
                                }`}
                        >
                            {action.icon && (
                                <i className={`${action.icon} text-3xl sm:text-4xl md:text-5xl mb-2 sm:mb-3 md:mb-4 ${action.color === "green"
                                        ? "text-green-600 dark:text-green-300"
                                        : action.color === "orange"
                                            ? "text-orange-600 dark:text-orange-300"
                                            : "text-blue-600 dark:text-blue-300"
                                    }`}></i>
                            )}
                            <span className={`text-sm sm:text-base md:text-lg font-semibold text-center px-2 ${action.color === "green"
                                    ? "text-green-800 dark:text-green-200"
                                    : action.color === "orange"
                                        ? "text-orange-800 dark:text-orange-200"
                                        : "text-blue-800 dark:text-blue-200"
                                }`}>
                                {action.label}
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </Dialog>
    );
}

ActionDialog.propTypes = {
    visible: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.string,
            onClick: PropTypes.func.isRequired,
            color: PropTypes.oneOf(["blue", "green", "orange"])
        })
    ).isRequired,
    title: PropTypes.string,
};

ActionDialog.defaultProps = {
    title: "Ödeme Paneli",
};

export default ActionDialog;